import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = { key: 0 }

import { computed, ref } from "vue";
import { TraceLinkDisplayProps } from "@/types";
import { artifactStore } from "@/hooks";
import { Typography } from "@/components/common";
import {
  ArtifactContentDisplay,
  ArtifactBodyDisplay,
} from "@/components/artifact/display";


/**
 * Displays a trace link's artifacts.
 */
const __default__ = {
  name: "TraceLinkDisplay",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    showOnly: {},
    trace: {}
  },
  setup(__props: any) {

const props = __props;

const splitterModel = ref(50);

const sourceArtifact = computed(() =>
  artifactStore.getArtifactById(props.trace.sourceId)
);
const targetArtifact = computed(() =>
  artifactStore.getArtifactById(props.trace.targetId)
);

const showOnlyArtifact = computed(() =>
  props.showOnly === "source" ? sourceArtifact.value : targetArtifact.value
);

const generated = computed(() => props.trace.traceType === "GENERATED");
const explanation = computed(() =>
  generated.value ? props.trace.explanation : undefined
);

return (_ctx: any,_cache: any) => {
  const _component_q_splitter = _resolveComponent("q-splitter")!

  return (_openBlock(), _createElementBlock("div", null, [
    (!!explanation.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_unref(Typography), {
            variant: "caption",
            value: "Explanation"
          }),
          _createVNode(_unref(Typography), {
            value: explanation.value,
            variant: "expandable",
            "default-expanded": "",
            "collapse-length": 0
          }, null, 8, ["value"])
        ]))
      : _createCommentVNode("", true),
    (!_ctx.showOnly)
      ? (_openBlock(), _createBlock(_component_q_splitter, {
          key: 1,
          modelValue: splitterModel.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((splitterModel).value = $event))
        }, {
          before: _withCtx(() => [
            (sourceArtifact.value)
              ? (_openBlock(), _createBlock(_unref(ArtifactBodyDisplay), {
                  key: 0,
                  artifact: sourceArtifact.value,
                  "display-title": "",
                  "display-divider": "",
                  "default-expanded": ""
                }, null, 8, ["artifact"]))
              : _createCommentVNode("", true)
          ]),
          after: _withCtx(() => [
            (targetArtifact.value)
              ? (_openBlock(), _createBlock(_unref(ArtifactBodyDisplay), {
                  key: 0,
                  artifact: targetArtifact.value,
                  "display-title": "",
                  "display-divider": "",
                  "default-expanded": ""
                }, null, 8, ["artifact"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["modelValue"]))
      : (showOnlyArtifact.value)
        ? (_openBlock(), _createBlock(_unref(ArtifactContentDisplay), {
            key: 2,
            artifact: showOnlyArtifact.value
          }, null, 8, ["artifact"]))
        : _createCommentVNode("", true)
  ]))
}
}

})